import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { Link } from "react-router-dom";

import "./card.scss";

function Card({ data }) {
    return (
        <Link to={"/" + data.id} className="card">
            <div className="card-details">
                <div className="card-title">
                    {/* Photo Artist Website */}
                    {data.title}
                </div>
                <div className="card-subtitle">
                    {/* Website created for show photographer works */}
                    {data.description}
                </div>
                <div className="card-date">
                    {/* 2021 */}
                    {data.date}
                </div>
            </div>
            <div className="card-controls">
                <ArrowCircleRightIcon className="card-arrow" />
            </div>
            <div className="card-image">
                <img src={"assets/projects/" + data.src + ".png"} alt="" />
            </div>
        </Link>
    )
}

export default Card